'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _menu = require('antd/lib/menu');

var _menu2 = _interopRequireDefault(_menu);

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _access = require('../helpers/access');

var _reduxRegexpRouter = require('redux-regexp-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubMenu = _menu2.default.SubMenu;

var AdminMenu = function (_React$Component) {
    _inherits(AdminMenu, _React$Component);

    function AdminMenu() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, AdminMenu);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdminMenu.__proto__ || Object.getPrototypeOf(AdminMenu)).call.apply(_ref, [this].concat(args))), _this), _this.onClickMenu = function (item) {
            var module = item.item.props.module;
            var dispatch = _this.props.dispatch;
            if (module.path) dispatch((0, _reduxRegexpRouter.pushPath)(module.url.replace('$', '')));
        }, _this.renderMenu = function (modules, collapsed) {
            var _this$props = _this.props,
                config = _this$props.config,
                user = _this$props.user;

            var activeModules = modules.filter(function (item) {
                return !item.hidden && (0, _access.checkAccess)(item, user);
            });
            return activeModules.map(function (module, key) {
                var item = void 0;
                var icon = module.icon,
                    title = module.title;

                if (!icon) {
                    item = _react2.default.createElement(
                        'span',
                        { className: 'nav-text' },
                        title
                    );
                } else {
                    item = collapsed ? _react2.default.createElement(
                        'span',
                        { className: 'nav-container' },
                        _react2.default.createElement(_icon2.default, { type: icon })
                    ) : _react2.default.createElement(
                        'span',
                        { className: 'nav-container' },
                        _react2.default.createElement(_icon2.default, { type: icon }),
                        _react2.default.createElement(
                            'span',
                            null,
                            title
                        )
                    );
                }

                if (module.subModules) {
                    return _react2.default.createElement(
                        SubMenu,
                        { key: key, title: item },
                        _this.renderMenu(module.subModules)
                    );
                } else {
                    return _react2.default.createElement(
                        _menu2.default.Item,
                        { key: module.url || key, module: module,
                            icon: module.icon },
                        item
                    );
                }
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(AdminMenu, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                config = _props.config,
                routing = _props.routing,
                collapsed = _props.collapsed;
            var modules = config.modules;


            var defaultPath = routing.location.pathname;

            return _react2.default.createElement(
                _menu2.default,
                { theme: 'dark', mode: 'inline', defaultSelectedKeys: [defaultPath],
                    onClick: this.onClickMenu },
                this.renderMenu(modules, collapsed)
            );
        }
    }]);

    return AdminMenu;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        config: state.config,
        routing: state.routing,
        user: state.user
    };
})(AdminMenu);
//# sourceMappingURL=AdminMenu.js.map


//////////////////
// WEBPACK FOOTER
// ./~/perx-uikit/dist/components/AdminMenu.js
// module id = 1272
// module chunks = 5